module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section-white"
  }, [_c('div', {
    staticClass: "appmsg_preview_area"
  }, [_c('div', {
    staticClass: "appmsg_preview_container"
  }, [_c('div', {
    attrs: {
      "id": "submitContent"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "appmsg_container_bd"
  }, [_c('div', {
    staticClass: "appmsg multi has_first_cover editing"
  }, [_c('div', {
    staticClass: "appmsg_content",
    attrs: {
      "id": "js_appmsg_preview"
    }
  }, [_vm._l((_vm.articals), function(item, index) {
    return [(index === 0) ? _c('div', {
      staticClass: "js_appmsg_item appmsg_item_wrp",
      class: _vm.id === index ? 'current' : '',
      on: {
        "click": function($event) {
          return _vm.handleClick(index)
        }
      }
    }, [_c('div', {
      staticClass: "first_appmsg_item",
      attrs: {
        "title": "第一篇图文"
      }
    }, [_c('div', {
      staticClass: "cover_appmsg_item"
    }, [_c('h4', {
      staticClass: "appmsg_title"
    }, [_c('a', {
      staticClass: "js_appmsg_title",
      attrs: {
        "href": "javascript:void(0);",
        "onclick": "return false;"
      }
    }, [(_vm.articals[0].title != '') ? [_vm._v("\n                          " + _vm._s(_vm.articals[0].title) + "\n                        ")] : [_vm._v("\n                          标题\n                        ")]], 2)]), _vm._v(" "), _c('div', {
      staticClass: "appmsg_thumb_wrp",
      style: ({
        backgroundImage: 'url(' + (item.thumb_url ? _vm.wximageurl + item.thumb_url : '') + ')'
      })
    }, [(!item.thumb_url) ? _c('div', {
      staticClass: "appmsg_thumb default"
    }, [_c('i', {
      staticClass: "icon_appmsg_thumb el-icon-picture"
    })]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "appmsg_edit_mask"
    }, [_c('a', {
      staticClass: "icon20_common iconfont icon-arrow-down sort_down_white",
      attrs: {
        "onclick": "return false;",
        "title": "下移"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.sortdown(index)
        }
      }
    })])])]) : _c('div', {
      staticClass: "js_appmsg_item appmsg_item_wrp",
      class: _vm.id === index ? 'current' : '',
      on: {
        "click": function($event) {
          return _vm.handleClick(index)
        }
      }
    }, [_c('div', {
      staticClass: "appmsg_item has_cover"
    }, [_c('div', {
      staticClass: "appmsg_thumb_wrp",
      style: ({
        backgroundImage: 'url(' + (item.thumb_url ? _vm.wximageurl + item.thumb_url : '') + ')'
      })
    }, [(!item.thumb_url) ? _c('div', {
      staticClass: "appmsg_thumb default"
    }, [_c('i', {
      staticClass: "icon_appmsg_thumb_small el-icon-picture"
    })]) : _vm._e()]), _vm._v(" "), _c('h4', {
      staticClass: "appmsg_title js_appmsg_title"
    }, [(item.title != '') ? [_vm._v("\n                      " + _vm._s(item.title) + "\n                    ")] : [_vm._v("\n                      标题\n                    ")]], 2), _vm._v(" "), _c('div', {
      staticClass: "appmsg_edit_mask"
    }, [_c('a', {
      staticClass: "icon20_common sort_up_white iconfont icon-arrow-up",
      attrs: {
        "title": "上移"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.sortup(index)
        }
      }
    }), _vm._v(" "), (index !== (_vm.articals.length - 1)) ? _c('a', {
      staticClass: "icon20_common sort_down_white icon icon-arrow-down",
      attrs: {
        "title": "下移"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.sortdown(index)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('el-popover', {
      attrs: {
        "placement": "bottom",
        "width": "220",
        "trigger": "click"
      },
      model: {
        value: (item.popVisible),
        callback: function($$v) {
          _vm.$set(item, "popVisible", $$v)
        },
        expression: "item.popVisible"
      }
    }, [_c('p', {
      staticClass: "content-padded content-center",
      staticStyle: {
        "font-size": "14px"
      }
    }, [_vm._v("确定删除这篇图文？")]), _vm._v(" "), _c('div', {
      staticClass: "content-center"
    }, [_c('el-button', {
      on: {
        "click": function($event) {
          item.popVisible = false
        }
      }
    }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.remove(index)
        }
      }
    }, [_vm._v("确定")])], 1), _vm._v(" "), (!_vm.isEditting) ? _c('a', {
      staticClass: "icon20_common del_media_white el-icon-delete2",
      attrs: {
        "slot": "reference",
        "title": "删除"
      },
      slot: "reference"
    }) : _vm._e()])], 1)])])]
  })], 2)]), _vm._v(" "), (!_vm.isEditting) ? _c('div', {
    staticClass: "create_access_primary appmsg_add",
    attrs: {
      "title": "添加一篇图文"
    },
    on: {
      "click": _vm.addmsg
    }
  }, [_c('i', {
    staticClass: "icon35_common el-icon-plus"
  })]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "appmsg_input_area"
  }, [_vm._l((_vm.articals), function(item, index) {
    return (_vm.id === index) ? [_c('el-form', {
      ref: "item",
      refInFor: true,
      attrs: {
        "model": item,
        "label-position": "top",
        "label-width": "80px"
      }
    }, [_c('div', {
      staticClass: "content-padded"
    }, [_c('el-form-item', {
      attrs: {
        "label": "标题"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "请输入标题"
      },
      model: {
        value: (item.title),
        callback: function($$v) {
          _vm.$set(item, "title", $$v)
        },
        expression: "item.title"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "作者"
      }
    }, [_c('el-input', {
      model: {
        value: (item.author),
        callback: function($$v) {
          _vm.$set(item, "author", $$v)
        },
        expression: "item.author"
      }
    })], 1), _vm._v(" "), _c('el-form-item', [_c('vue-html5-editor', {
      ref: "editor",
      refInFor: true,
      attrs: {
        "content": item.viewcontent,
        "id": index,
        "height": 360
      },
      on: {
        "change": _vm.updateContent
      }
    })], 1), _vm._v(" "), _c('el-form-item', [_c('el-checkbox', {
      model: {
        value: (item.hasLink),
        callback: function($$v) {
          _vm.$set(item, "hasLink", $$v)
        },
        expression: "item.hasLink"
      }
    }, [_vm._v("原文链接")]), _vm._v(" "), (item.hasLink) ? _c('el-input', {
      attrs: {
        "placeholder": ""
      },
      model: {
        value: (item.content_source_url),
        callback: function($$v) {
          _vm.$set(item, "content_source_url", $$v)
        },
        expression: "item.content_source_url"
      }
    }, [_c('template', {
      slot: "prepend"
    }, [_vm._v("Http://")])], 2) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "content-padded appmsg_edit_highlight_area"
    }, [_c('h3', {
      staticClass: "header-title"
    }, [_vm._v("发布样式编辑")]), _vm._v(" "), _c('div', {
      staticClass: "header_tips"
    }, [_vm._v("封面小图片 "), _c('span', {
      staticClass: "form-text-tip"
    }, [_vm._v("建议尺寸：200像素 * 200像素")])]), _vm._v(" "), _c('el-form-item', [_c('div', [_c('el-button', {
      on: {
        "click": _vm.addThumbPreview
      }
    }, [_vm._v("从图片库选择")])], 1), _vm._v(" "), (item.thumb_url) ? _c('div', {
      staticClass: "cover_preview",
      style: ({
        backgroundImage: 'url(' + (item.thumb_url ? _vm.wximageurl + item.thumb_url : '') + ')'
      })
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "header_tips"
    }, [_vm._v("摘要 "), _c('span', {
      staticClass: "form-text-tip"
    }, [_vm._v("选填，如果不填写会默认抓取正文前54个字")])]), _vm._v(" "), _c('el-form-item', [_c('el-input', {
      attrs: {
        "type": "textarea",
        "autosize": {
          minRows: 5,
          maxRows: 8
        },
        "resize": "none",
        "maxlength": 120
      },
      model: {
        value: (item.digest),
        callback: function($$v) {
          _vm.$set(item, "digest", $$v)
        },
        expression: "item.digest"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "content-num"
    }, [_vm._v(_vm._s(item.digest.length) + "/120")])], 1)], 1)])] : _vm._e()
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "appmsg_tpl_area "
  }, [_c('div', {
    staticClass: "appmsg_tpl_container"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "appmsg_container_bd"
  }, [_c('ul', {
    staticClass: "tpl_list",
    attrs: {
      "id": "js_media_list"
    }
  }, [_c('li', {
    staticClass: "tpl_item img",
    on: {
      "click": _vm.addImgPreview
    }
  }, [_c('i', {
    staticClass: "iconfont icon-image"
  }), _vm._v("图片\n          ")])]), _vm._v(" "), _c('imgPicker', {
    attrs: {
      "dialog-visible": _vm.thumbDialog,
      "sc-status": _vm.isGetThumb
    },
    on: {
      "chooseImg": _vm.pickThumb,
      "closeImgDialog": _vm.closeThumbDialog
    }
  }), _vm._v(" "), _c('imgPicker', {
    attrs: {
      "dialog-visible": _vm.imgDialog,
      "sc-status": _vm.isGetImage
    },
    on: {
      "chooseImg": _vm.pickImg,
      "closeImgDialog": _vm.closeImgDialog
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "tool_area_wrp"
  }, [_c('div', {
    staticClass: "tool_area"
  }, [_c('div', {
    staticClass: "tool_bar content-center"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("预览")])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "appmsg_container_hd"
  }, [_c('h4', {
    staticClass: "appmsg_container_title"
  }, [_vm._v("图文列表")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "appmsg_container_hd"
  }, [_c('h4', {
    staticClass: "appmsg_container_title"
  }, [_vm._v("多媒体")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-74444374", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74444374"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/brand/wechat/artical/new_artical.vue
// module id = 2826
// module chunks = 0